import React, { useEffect, useState, useRef } from "react";
import { ref, onValue, push, get } from "firebase/database";
import { db } from "../services/firebase";
import { useNavigate, useParams } from "react-router-dom";
import "./TestMCQ.css";
import { FaBookOpen, FaCheckCircle, FaEdit, FaTimesCircle, FaClock, FaListOl, FaSyncAlt, FaBan, FaWifi, FaMarker, FaExclamationTriangle, FaLightbulb, FaLaptopCode, FaBullseye } from "react-icons/fa";
import { FaDesktop, FaLaptop, FaMemory, FaMicrochip } from "react-icons/fa";
import {  FaArrowLeft, FaRocket } from "react-icons/fa";
import ExamSecurityMonitor from "./ExamSecurityMonitor";

const TestMCQ = ({ user }) => {
  const { quizId } = useParams();
  const [quizMeta, setQuizMeta] = useState({});
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const answersRef = useRef({});
  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const [countdownLeft, setCountdownLeft] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [startCountdown, setStartCountdown] = useState(null);
  const [showReview, setShowReview] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [systemInfo, setSystemInfo] = useState({});
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const navigate = useNavigate();
  const quizTitle = quizMeta?.title || "MCQ Test";

  const formatTime = (s) => {
    // can we make it in Hr:Min:Sec format
    if (s === null || s === undefined) return "00:00";

    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;

    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
  };

  // 🔁 Sync answers to ref
  useEffect(() => {
    answersRef.current = answers;
  }, [answers]);

  useEffect(() => {
    const quizRef = ref(db, `quizzes/${quizId}`);
    onValue(quizRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setQuizMeta(data);
        const shuffledQuestions = Object.values(data.questions || {}).sort(() => Math.random() - 0.5);
        setQuestions(shuffledQuestions);
      }
    });
  }, [quizId]);

  // useEffect(() => {
  //   if (!quizMeta?.startTime) return;
  //   const now = Date.now();
  //   const start = new Date(quizMeta.startTime).getTime();
  //   const end = new Date(quizMeta.endTime).getTime();

  //   if (start && now < start) {
  //     setIsActive(false);
  //     setStartCountdown(Math.floor((start - now) / 1000));
  //   } else if (end && now > end) {
  //     setIsActive(false);
  //   } else {
  //     setIsActive(true);
  //   }
  // }, [quizMeta]);

  useEffect(() => {
  if (!quizMeta?.startTime || !quizMeta?.endTime) return;

  const now = Date.now();
  const start = new Date(quizMeta.startTime).getTime();
  const end = new Date(quizMeta.endTime).getTime();

  if (now < start) {
    // test not started yet
    setIsActive(false);
    setStartCountdown(Math.floor((start - now) / 1000));
    return;
  }

  if (now >= end) {
    // test already ended
    setIsActive(false);
    return;
  }

  // ✅ calculate remaining time
  let allotted = quizMeta?.countdown ? quizMeta.countdown * 60 : null; // seconds
  let remainingWindow = Math.floor((end - now) / 1000);

  // Agar countdown diya hai to min le lo
  let effectiveTime = allotted ? Math.min(allotted, remainingWindow) : remainingWindow;

  setCountdownLeft(effectiveTime);
  setIsActive(true);

}, [quizMeta]);


useEffect(() => {
  if (!isActive || !countdownLeft) return;

  let timer = setInterval(() => {
    setCountdownLeft(prev => {
      if (prev <= 1) {
        clearInterval(timer);
        handleSubmit(true); // auto-submit
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  return () => clearInterval(timer);
}, [isActive, countdownLeft]);


  useEffect(() => {
    if (startCountdown === null) return;
    const timer = setInterval(() => {
      setStartCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsActive(true);
          return null;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [startCountdown]);

  // useEffect(() => {
  //   if (!isActive || questions.length === 0) return;

  //   let timer;
  //   if (quizMeta?.countdown) {
  //     setCountdownLeft(parseInt(quizMeta.countdown) * 60);
  //     timer = setInterval(() => {
  //       setCountdownLeft((prev) => {
  //         if (prev <= 1) {
  //           clearInterval(timer);
  //           handleSubmit(true); // ✅ Auto-submit using ref answers
  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   } else {
  //     timer = setInterval(() => {
  //       setSecondsElapsed((prev) => prev + 1);
  //     }, 1000);
  //   }
  //   return () => clearInterval(timer);
  // }, [quizMeta, isActive, questions]);

  useEffect(() => {
  let timer;

  // Only run if quiz is active or waiting to start
  if (startCountdown !== null) {
    // Pre-test countdown
    timer = setInterval(() => {
      setStartCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsActive(true);
          return null;
        }
        return prev - 1;
      });
    }, 1000);
  } else if (isActive && questions.length > 0) {
    // Main test timer
    if (quizMeta?.countdown) {
      setCountdownLeft(prev => prev ?? quizMeta.countdown * 60);
      timer = setInterval(() => {
        setCountdownLeft(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            handleSubmit(true); // auto-submit safely
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      timer = setInterval(() => {
        setSecondsElapsed(prev => prev + 1);
      }, 1000);
    }
  }

  return () => clearInterval(timer);
}, [startCountdown, isActive, questions, quizMeta]);


  useEffect(() => {
    const info = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      deviceMemory: navigator.deviceMemory || "N/A",
      cores: navigator.hardwareConcurrency || "N/A",
    };
    setSystemInfo(info);
  }, []);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleOptionChange = (qIndex, selected) => {
    setAnswers((prev) => ({ ...prev, [qIndex]: selected }));
  };

  const getScore = (finalAnswers) => {
    let score = 0;
    questions.forEach((q, i) => {
      if (finalAnswers[i] === q.correctAnswer) score += 1;
    });
    return score;
  };

  const handleSubmit = async (isAutoSubmit = false) => {
    if (submitting) return;
    setSubmitting(true);

    const usedAnswers = isAutoSubmit ? answersRef.current : answers;
    const finalAnswers = {};
    questions.forEach((_, i) => {
      finalAnswers[i] = usedAnswers[i] || null;
    });

    const correct = getScore(finalAnswers);
    const total = questions.length;
    const accuracy = ((correct / total) * 100).toFixed(2);
    const timeTaken = quizMeta?.countdown
      ? `${quizMeta.countdown * 60 - countdownLeft}s`
      : `${secondsElapsed}s`;

    const submissionDetails = {
      user: user?.email || "guest",
      quizId,
      testType: "mcq",
      topic: quizMeta?.topic || "General",
      quizTitle,
      score: correct,
      accuracy,
      timeTaken,
      submittedAt: new Date().toISOString(),
      source: "Dashboard",
      testId: `mcq-${quizId}-${Date.now()}`,
      answers: questions.map((q, i) => ({
        qid: q.id || i,
        question: q.question,
        selected: finalAnswers[i],
        correct: q.correctAnswer,
        explanation: q.explanation || "",
      })),
    };

    try {
      if (!quizMeta.allowReattempt && user && !isAutoSubmit) {
        const resultRef = ref(db, "results");
        const snapshot = await get(resultRef);
        const data = snapshot.val();
        const attempted = Object.values(data || {}).some(
          (entry) => entry.user === user.email && entry.quizId === quizId
        );
        if (attempted) {
          alert("❌ You have already attempted this test.");
          setSubmitting(false);
          return;
        }
      }

      await push(ref(db, "results"), submissionDetails);
      localStorage.setItem("latestMCQResult", JSON.stringify(submissionDetails));

      if (isAutoSubmit) {
        alert("⏳ Time's up! Auto-submitting your answers.");
      }

      if (quizMeta?.showResultAfterSubmit) {
        navigate("/mcq-result");
      } else if (quizMeta?.delayedResultTime) {
        alert(`⏱️ Results will be available after ${quizMeta.delayedResultTime} minutes.`);
        navigate("/dashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error submitting:", error);
    } finally {
      setSubmitting(false);
    }
  };

  if (showReview) {
    const total = questions.length;
    const attempted = Object.keys(answers).length;
    const left = total - attempted;
    return (
      // <div className="review-page">
      //   <h2>📋 Review Before Submit</h2>
      //   <p>✅ Attempted: {attempted}</p>
      //   <p>❌ Left: {left}</p>
      //   <button onClick={() => setShowReview(false)}>🔙 Back to Test</button>
      //   <button onClick={() => handleSubmit(false)} disabled={submitting}>
      //     🚀 Final Submit
      //   </button>
      // </div>
      <div className="review-page">
        <h2>📋 Review Before Submit</h2>
        <p><FaCheckCircle className="text-green-500" /> Attempted: {attempted}</p>
        <p><FaTimesCircle className="text-red-500" /> Left: {left}</p>
        <button onClick={() => setShowReview(false)}><FaArrowLeft /> Back to Test</button>
        <button onClick={() => handleSubmit(false)} disabled={submitting}><FaRocket /> Final Submit</button>
      </div>
    );
  }





  return (
    <div className="mcq-test-container">
      <div className="mcq-header">
        <h2>📘 {quizTitle}</h2>

        {startCountdown !== null && (
          <div className="pre-test-check">
            <h3><FaDesktop /> System Check Before Test</h3>

            <p>
              Status: {isOnline ? <FaCheckCircle className="status-online" /> : <FaTimesCircle className="status-offline" />}{" "}
              {isOnline ? "Online" : "Offline. Please check your internet connection."}
            </p>

            <p><FaLaptop /> Platform: {systemInfo.platform}</p>
            <p><FaDesktop /> Browser: {systemInfo.userAgent}</p>
            <p>🖥️ Screen: {systemInfo.screenWidth} x {systemInfo.screenHeight}</p>
            <p><FaMemory /> RAM: {systemInfo.deviceMemory} GB</p>
            <p><FaMicrochip /> CPU Cores: {systemInfo.cores}</p>
          </div>
        )}

        <br />


        {startCountdown !== null && (
          // <div className="mcq-timer">
          //   ⏳ Test starts in: <strong>{formatTime(startCountdown)}</strong>
          //   <div className="test-instructions">
          //     <h3>📘 Test Instructions:</h3>
          //     <ul>
          //       <li>✅ You can change answers before final submission.</li>
          //       <li>📝 Final answers will be locked only after submit or auto-submit.</li>
          //       <li>❌ Correct answers will be shown only after submitting.</li>
          //     </ul>
          //   </div>
          // </div>


          <div className="tl-timerBox-1_0_0_">
            ⏳ Test starts in: <strong>{formatTime(startCountdown)}</strong>
            <div className="tl-instructions-1_0_1_">
              <h3><FaBookOpen className="icon book" /> Test Instructions:</h3>
              <ul>
                <li><FaCheckCircle className="icon" /> You can change answers before final submission.</li>
                <li><FaEdit className="icon" /> Final answers will be locked only after submit or auto-submit.</li>
                <li><FaTimesCircle className="icon" /> Correct answers will be shown only after submitting.</li>
                <li><FaClock className="icon" /> The test is time-bound; manage your time wisely.</li>
                <li><FaListOl className="icon" /> Each question carries equal marks unless otherwise specified.</li>
                <li><FaSyncAlt className="icon" /> You can navigate freely between questions before submission.</li>
                <li><FaBan className="icon" /> Do not refresh or close the window once the test has started.</li>
                <li><FaWifi className="icon" /> An active internet connection is required throughout the test.</li>
                <li><FaMarker className="icon" /> Use the “Mark for Review” option to revisit questions later.</li>
                <li><FaExclamationTriangle className="icon warning" /> The test will auto-submit when the timer runs out.</li>
                <li><FaLightbulb className="icon" /> Read each question carefully before answering.</li>
                <li><FaLaptopCode className="icon" /> Use only the allowed devices; multiple logins may terminate your test.</li>
                <li><FaBullseye className="icon success" /> Once submitted, answers cannot be changed.</li>
                <li><FaExclamationTriangle className="icon warning" /> This exam is being monitored for security violations.</li>
                <li><FaBan className="icon danger" /> Switching tabs, copying, or using developer tools is prohibited.</li>
              </ul>
            </div>
          </div>

        )}


        {isActive && (

          <div className="mcq-timer">
            ⏱️ {quizMeta?.countdown ? formatTime(countdownLeft) : formatTime(secondsElapsed)}
          </div>

        )}

        {!isActive && startCountdown === null && (
          <p style={{ color: "red" }}>🚫 This test is not available right now.</p>
        )}
      </div>

      {isActive &&
        questions.map((q, index) => (
          <div className="mcq-question-card" key={index}>
            <h4>Q{index + 1}: {q.question}</h4>
            <ul className="mcq-options">
              {q.options.map((opt, i) => {
                const isSelected = answers[index] === opt;
                return (
                  <li key={i}>
                    <label
                      className={`mcq-option-label ${isSelected ? "selected" : ""}`}
                      onClick={() => handleOptionChange(index, opt)}
                    >
                      <input
                        type="radio"
                        name={`q-${index}`}
                        value={opt}
                        checked={isSelected}
                        readOnly
                      />
                      {opt}
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}

      {/* //  <li><FaExclamationTriangle className="icon warning" /> This exam is being monitored for security violations.</li>
       // <li><FaBan className="icon danger" /> Switching tabs, copying, or using developer tools is prohibited.</li> */}

      {isActive && questions.length > 0 && (
        <button className="mcq-submit-btn" onClick={() => setShowReview(true)} disabled={submitting}>
          📋 Review & Submit
        </button>
      )}

      <ExamSecurityMonitor />
    </div>
  );
};

export default TestMCQ;
